import React, {useState} from 'react';
import './App.css';
import {BrowserRouter as Router} from 'react-router-dom';
import Login from './Login';
import * as PropTypes from "prop-types";
import {Navbar} from "./components/Navbar";

Navbar.propTypes = {
    loggedIn: PropTypes.bool,
    onLogin: PropTypes.func
};

function App() {
    const [token, setToken] = useState(null);
    const [roles, setRoles] = useState([]);

    const handleLogin = (token, roles) => {
        setToken(token);
        setRoles(roles);
    }

    const handleLogout = () => {
        setToken(null);
        setRoles([]);
    }

    return (
        <Router>
            <div className="App">
                <header>
                    {!!token ? (
                        <button onClick={handleLogout}>Abmelden</button>
                    ) : (
                        <Login onLogin={handleLogin}/>
                    )}
                </header>
                <Navbar loggedIn={!!token} token={token} onLogin={handleLogin}/>
            </div>
        </Router>
    );
}

export default App;
